import React from 'react';
import { CarCard } from '@perxis-auto/ui-kit/lib/components/CarCard';

import getCarLocation from '@/features/cars/helpers/getCarLocation';

import { CardLocationProps } from './CardLocation.types';

/**
 * Блок местоположения автомобиля, на странице автомобиля.
 */
function CardLocation({ data, locationIds, isLoading = false }: CardLocationProps) {
  if (isLoading) {
    return <CarCard.LocationSkeleton />;
  }

  if (!data) {
    return null;
  }

  const location = getCarLocation(data, locationIds);

  if (!location) {
    return null;
  }

  return <CarCard.Location location={location} />;
}

export default CardLocation;
